enum SurveyState {
  loading = 'loading',
  survey = 'survey',
  done = 'done',
  error = 'error',
  pending = 'pending',
}

export default SurveyState;
